import React from 'react';
import { ThemeProvider, withTheme } from 'styled-components';
import { dynamicYieldTheme } from './theme';
import Wrapper from './index.styles';
export var DynamicYield = function (_a) {
    var _b = _a.dataDyId, dataDyId = _b === void 0 ? 'empty' : _b, margin = _a.margin, padding = _a.padding;
    return (React.createElement(ThemeProvider, { theme: dynamicYieldTheme },
        React.createElement(Wrapper, { "data-dy": dataDyId, customMargin: margin, customPadding: padding })));
};
export default withTheme(DynamicYield);
//# sourceMappingURL=index.js.map